// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"580":"f1436cb801d184c8","4624":"479cf45c3d30ff79","7896":"7cdd8eb6db380ae3","9004":"479cf45c3d30ff79"}[chunkId] + ".css";
};